module.exports = __webpack_public_path__ + "img/production-team.204e283a.jpg";